import { useEffect } from 'react'

import {
  COMPACT_AUTO_RENEW_DELAY_MS,
  FULL_AUTO_RENEW_DELAY_MS,
  MAX_AUTO_RENEWS,
  QR_PANEL_STATUS
} from '../constants'
import type { QrPanelState, QrPanelVariant, QrStartSession } from '../types'

type UseQrAutoRenewParams = {
  autoRenewCount: number
  status: QrPanelState['status']
  variant: QrPanelVariant
  renewTimeoutRef: { current: ReturnType<typeof setTimeout> | null }
  startSession: QrStartSession
}

export const useQrAutoRenew = ({
  autoRenewCount,
  status,
  variant,
  renewTimeoutRef,
  startSession
}: UseQrAutoRenewParams) => {
  useEffect(() => {
    if (status !== QR_PANEL_STATUS.EXPIRED) {
      return
    }

    if (autoRenewCount >= MAX_AUTO_RENEWS) {
      return
    }

    const renewDelayMs =
      variant === 'compact'
        ? COMPACT_AUTO_RENEW_DELAY_MS
        : FULL_AUTO_RENEW_DELAY_MS

    renewTimeoutRef.current = setTimeout(() => {
      startSession('auto')
    }, renewDelayMs)

    return () => {
      if (renewTimeoutRef.current) {
        clearTimeout(renewTimeoutRef.current)
        renewTimeoutRef.current = null
      }
    }
  }, [autoRenewCount, renewTimeoutRef, startSession, status, variant])
}
